import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService, fromMinutesToMilliseconds } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class HardSessionConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getHardSessionLimitIsEnabled(): boolean {
		return this.configService.get((x) => x.core.responsibleGaming.hardSessionLimit!.isEnabled, false);
	}

	getHardSessionLimitDuration(): number {
		return this.configService.get((x) => x.core.responsibleGaming.hardSessionLimit!.sessionDuration, 0);
	}

	getHardSessionPollingInterval(): number {
		return this.configService.get(
			(x) => x.core.responsibleGaming.hardSessionLimit?.hardSessionPollingInterval,
			fromMinutesToMilliseconds(10)
		);
	}

	getNotificationBeforeLogoutTime(): number {
		return this.configService.get(
			(x) => x.core.responsibleGaming.hardSessionLimit!.showAlertBeforeLogout,
			fromMinutesToMilliseconds(10)
		);
	}
}
